import React from 'react'

const DateFilter = ({filters,handleChange}) => {
  return (
    <div className='col-3 add'>
      

  <input type="date" className='form-control' onChange={(e)=>handleChange("date",e.target.value)} value={filters.date} />

    </div>
  )
}

export default DateFilter